






























import type { PropType, Ref } from '@vue/composition-api';
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
} from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { SigningTheme } from '../../signing-theme/types/theme';
import { BrandingHelper } from '../../signing-theme/helpers/branding.helper';

export default defineComponent({
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    newCommentsCount: {
      type: Number,
      required: true,
    },
    theme: {
      type: Object as PropType<SigningTheme>,
      default: null,
    },
    isDsr: {
      type: Boolean,
    },
  },
  setup(props) {
    const observer: Ref<IntersectionObserver> = ref(null);
    const chatFab: Ref<HTMLButtonElement> = ref(null);

    const hasNewComments = computed(() => props.newCommentsCount > 0);
    const hasTheme = computed(() => !!props.theme && !!props.theme.accentColor);

    const chatFabStyle = computed(() => {
      if (hasTheme.value) {
        return {
          '--chat-background-color': BrandingHelper.getBackgroundColor(
            props.theme.accentColor,
            false,
            false
          ),
          '--chat-background-color-hover': BrandingHelper.getBackgroundColorHover(
            props.theme.accentColor,
            false,
            false
          ),
          '--icon-color': BrandingHelper.getTextColor(props.theme.accentColor, false, false),
        };
      }

      return {};
    });

    onMounted(async () => {
      if (!props.isDsr) {
        return;
      }

      await nextTick();
      const navigationButtons = document.querySelector('div.navigation-buttons') as HTMLDivElement;
      if (!navigationButtons) {
        return;
      }

      observer.value = new IntersectionObserver(
        entries => {
          const [{ isIntersecting }] = entries;
          if (isIntersecting) {
            chatFab.value.classList.add('add-margin');
          }

          if (!isIntersecting) {
            chatFab.value.classList.remove('add-margin');
          }
        },
        {
          threshold: 0.1,
        }
      );

      observer.value.observe(navigationButtons);
    });

    onBeforeUnmount(() => {
      if (!props.isDsr) {
        return;
      }

      if (observer.value) {
        observer.value.disconnect();
      }
    });

    return {
      chatFab,
      chatFabStyle,
      hasTheme,
      hasNewComments,
      t,
    };
  },
});
